export default function assertively<T>(value: T | Error): T {
    if (value instanceof Error) throw value;
    else return value;
}